import { createElement, FC } from "react";
import { IDiscordAttachment } from "#api/discord";
import { THUMBNAILS_PREPEND } from "#env/env-vars";

import * as styles from "./styles.module.scss";

const imageTypes = [
  "apng",
  // "avif", // Not well-supported
  "gif",
  "jpg",
  "png",
  "webp",
];

const videoTypes = [
  "webm",
  "mp4",
]

interface IAttachmentProps {
  path: string;
  name: string;
}

function Image({ path, name }: IAttachmentProps) {
  // TODO: Zoom-on-click like Discord does.
  return (
    <a href={`https://kemono.su/data${path}`} target="_blank">
      <img src={`${THUMBNAILS_PREPEND}/thumbnail/data${path}`} alt={name} loading="lazy" />
    </a>
  );
}

function Video({ path, name }: IAttachmentProps) {
  return (
    <video src={path} />
  );
}

// function Text({ path, name }: IAttachmentProps) {
//   return (

//   )
// }

const archives = ["7z", "rar", "zip", "tar"]

function Download({ path, name }: IAttachmentProps) {
  let ext = path.split(".")[1];

  return (
    <div className={styles.downloadAttachment}>
      <img src={archives.includes(ext) ? "/static/discord/archive.svg" : "/static/discord/file.svg"} />
      <div>
        <a href={path}>{name}</a>
        <span>
          {/* TODO: filesize */}
        </span>
      </div>
    </div>
  );
}

const attachmentMapping: {[key: string]: FC<IAttachmentProps>} = {
  "gif": Image,
  "png": Image,
  "jpg": Image,
  "webp": Image,
  "webm": Video,
  "mp4": Video,
  // "mp3": Audio,
  // "ogg": Audio,
  // "txt": Text,
}

interface IProps {
  attachments: IDiscordAttachment[];
}

export function Attachments({ attachments }: IProps) {
  if (!attachments.length) {
    return;
  }

  return (
    <div className={styles.attachmentContainer}>
      {attachments.map(attachment => {
        let ext = attachment.path.split('.')[1];
        return createElement(attachmentMapping[ext] ?? Download, attachment);
      })}
    </div>
  )
}
